<template>
<div>
  
    
      <!-- <LocalSystemsContainer /> -->
      <!-- <div class="flag">
        <span class="mode inside">INSIDE</span>
        <span class="commission">{{ billing_account.comission.inside || 3}}%</span>
      </div>
      <small class="status-flag active">Активна до 12.12.12</small>
      <div class="flag">
        <span class="mode preorder">TAKEAWAY</span>
        <span class="commission">{{ billing_account.comission.preorder || 3}}%</span>
      </div>
      <small class="status-flag end">Закінчилась 02.02.12</small>
      <div class="flag">
        <span class="mode delivery">DELIVERY</span>
        <span class="commission">{{ billing_account.comission.delivery || 3}}%</span>
      </div>
      <small class="status-flag">Неактивна</small>
      <div class="flag">
        <span class="mode reserve">RESERVE</span>
        <span class="commission fix-price">5 UAH</span>
      </div>
      <small class="status-flag active">Активна до 12.12.12</small>-->
     

    

    <!-- <div v-if="deposit_modal" class="sub-container">
      <header>
        <h4 @click="deposit_modal = false">< Повернутись</h4>
        <h2>Поповнити рахунок</h2>
      </header>
      <div class="choose-period">
        <h3>Сума поповнення</h3>
        <div
          class="period-box mt-0"
          :class="{
            'active': amount == 300 && !custom_amount
          }"
          @click="selectAmount(300)"
        >
          <p>300 грн</p>
        </div>
        <div
          class="period-box d-flex justify-content-between"
          :class="{
            'active': amount == 500 && !custom_amount
          }"
          @click="selectAmount(500)"
        >
          <p>500 грн</p>
        </div>
        <div class="period-box p-0">
          <input placeholder="Ввести суму" v-model.number="custom_amount" />
        </div>
        <form
          method="POST"
          action="https://www.liqpay.ua/api/3/checkout"
          accept-charset="utf-8"
          target="_blank"
        >
          <input type="hidden" name="data" :value="form.data" />
          <input type="hidden" name="signature" :value="form.signature" />
          <button class="pay" :disabled="generating_form">Оплатити ({{target_amount}} грн.)</button>
        </form>
        <img src="../../assets/liqpay.png" alt />
      </div>
      <div class="payment-block">
        <img src="/icons/visa-card.svg" class="take2pay" />
        <img src="/icons/ms-card.svg" class="take2pay" />
      </div>
    </div>-->
    <DepositModal v-if="deposit_modal" @close="deposit_modal = false" />

    <!-- <BillingHistoryModal /> -->
  </div>
</template>

<script>
import moment from "moment";
import BillingAPI from "@/api/billing";

import BillingHistoryModal from "@/components/modals/BillingHistoryModal.vue";

import DepositModal from "@/components/billing/DepositModal.vue";
import LocalSystems from '@/components/general/LocalSystems.vue'
import MarketPlaceModes from '@/components/general/MarketPlaceModes.vue'
export default {
 
  data() {
    return {
      billsHistory: false,
     
      form: {},
    
      custom_amount: null,
      generating_form: false,

     
    };
  },
  watch: {
    amount() {
      this.generateForm();
    },
    custom_amount() {
      this.generateForm();
    }
  },
  computed: {
    
   
    
    target_amount() {
      return this.custom_amount || this.amount;
    },
   
    
  },
  methods: {
   
    fetchLastTransactions() {
      BillingAPI.getTransactions(3)
        .then(data => {
          this.last_transactions = data.transactions;
        })
        .catch(error => {});
    },
    checkFeatureMode(mode) {
      return this.$store.getters['worldwide/checkSystem'](mode);
    }
  },
  mounted() {
    this.fetchLastTransactions();
  },
  components: {
    BillingHistoryModal,
    // SubscriptionBadge,
    DepositModal,
    LocalSystems,
    MarketPlaceModes
  }
};
</script>

<style scoped>

.sub-container {
  height: 100vh;
  width: 100%;
  background: black;
  position: fixed;
  top: 0;
  z-index: 5;
  left: 0;
  right: 0;
}

.take2pay {
  height: 4vh;
  margin-top: 1.7vh;
  width: 8vh;
}

</style>